export enum SkillLevels {
    Untrained = 0,
    Trained = 2,
    Expert = 4,
    Master = 6,
    Legendary = 8,
}

export enum SkillLevelMinimumCharacterLevels {
    Trained = 1,
    Expert = 2,
    Master = 7,
    Legendary = 15,
}

export const MaxSkillLevel = 8;

export const skillLevelBaseStep = 2;
